import React, {Component} from 'react';
import Col from 'react-bootstrap/Col';
import { NavLink } from 'react-router-dom';
import { formatTitle } from '../../controller/index'

export default class MainSolutions extends Component {
	dataCorporate = () => {
		return [
			{
				'title': 'nexatel',
				'url':'/nexatel',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_inet.png',
						'title': 'Internet Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_it_support.png',
						'title': 'IT Support',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_infra.png',
						'title': 'Network Infrastructure',
					}
				]
			},
			{
				'title': 'nexaaps',
				'url':'/nexaapps',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_web.png',
						'title': 'Custom Software Development Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_web.png',
						'title': 'Web Design And Development',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_mobile.png',
						'title': 'Mobile Application Development',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'API Development Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_pay.png',
						'title': 'Payment Integration',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_it_staff.png',
						'title': 'IT Staff',
					},
				]
			},
			{
				'title': 'nexadata',
				'url':'/nexadata',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_colocation.png',
						'title': 'Colocation',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_hosting.png',
						'title': 'Hosting Solutions',
					},
				]
			},
			{
				'title': 'nexadigital',
				'url':'/nexadigital',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Media Planning',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Multimedia Project',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_email.png',
						'title': 'Whatsapp, Email, & SMS Broadcast Engine',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Graphic Design as a Service',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'OOH Advertising',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Social Media Management',
					},
				]
			},
			{
				'title': 'solution',
				'url':'/solution',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Data Center',
					}
				]
			}
			
		]
	}

	dataEducation = () => {
		return [
			{
				'title': 'nexatel',
				'url':'/nexatel',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_inet.png',
						'title': 'Internet Services',
					}
				]
			},
			{
				'title': 'nexaapps',
				'url':'/nexaapps',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Custom Software Development Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_web.png',
						'title': 'Web Design And Development',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_pay.png',
						'title': 'Payment Integration',
					}
				]
			},
			{
				'title': 'nexadata',
				'url':'/nexadata',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_colocation.png',
						'title': 'Colocation',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_hosting.png',
						'title': 'Hosting Solutions',
					}
				]
			},
			{
				'title': 'nexadigital',
				'url':'/nexadigital',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_email.png',
						'title': 'Whatsapp, Email, & SMS Broadcast Engine',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Data Center Infrastructure Solution',
					}
				]
			},
			{
				'title': 'solution',
				'url':'/solution',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Hardware and Supporting Instruments as a Service',
					}
				]
			}
		]
	}

	dataGoverment = () => {
		return [
			{
				'title': 'nexatel',
				'url':'/nexatel',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_inet.png',
						'title': 'Internet Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_it_support.png',
						'title': 'IT Support',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_infra.png',
						'title': 'Network Infrastructure',
					}
				]
			},
			{
				'title': 'nexaapps',
				'url':'/nexaapps',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Custom Software Development Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_web.png',
						'title': 'Web Design And Development',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Mobile Application Development',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'API Development Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_pay.png',
						'title': 'Payment Integration',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_it_staff.png',
						'title': 'IT Staff',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_colocation.png',
						'title': 'Colocation',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_hosting.png',
						'title': 'Hosting Solutions',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_email.png',
						'title': 'Whatsapp, Email, & SMS Broadcast Engine',
					}
				]
			},
			{
				'title': 'solution',
				'url':'/solution',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Design & Planning',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Data Center Infrastructure Solution',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Monitoring / Situation Room',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Hardware and Supporting Instruments as a Service',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Infrastructure as a Service',
					}
				]
			}
		]
	}

	dataHospitally = () => {
		return [
			{
				'title': 'nexatel',
				'url':'/nexatel',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_inet.png',
						'title': 'Internet Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_it_support.png',
						'title': 'IT Support',
					}
				]
			},
			{
				'title': 'nexaapps',
				'url':'/nexaapps',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Custom Software Development Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_web.png',
						'title': 'Web Design And Development',
					}
				]
			},
			{
				'title': 'nexadata',
				'url':'/nexadata',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_colocation.png',
						'title': 'Colocation',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_hosting.png',
						'title': 'Hosting Solutions',
					}
				]
			},
			{
				'title': 'nexadigital',
				'url':'/nexadigital',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_email.png',
						'title': 'Whatsapp, Email, & SMS Broadcast Engine',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Social Media Management',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Graphic Design as a Service',
					}
				]
			}
		]
	}

	dataManufacture = () => {
		return [
			{
				'title': 'nexatel',
				'url':'/nexatel',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_inet.png',
						'title': 'Internet Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_it_support.png',
						'title': 'IT Support',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_infra.png',
						'title': 'Network Infrastructure',
					}
				]
			},
			{
				'title': 'nexaapps',
				'url':'/nexaapps',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Custom Software Development Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_web.png',
						'title': 'Web Design And Development',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Mobile Application Development',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'API Development Services',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_pay.png',
						'title': 'Payment Integration',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_it_staff.png',
						'title': 'IT Staff',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_colocation.png',
						'title': 'Colocation',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_hosting.png',
						'title': 'Hosting Solutions',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_email.png',
						'title': 'Whatsapp, Email, & SMS Broadcast Engine',
					}
				]
			},
			{
				'title': 'solution',
				'url':'/solution',
				'arr_data':[
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Data Center Infrastructure Solution',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Hardware and Supporting Instruments as a Service',
					},
					{
						'url_image': 'https://minio.nexa.net.id/nexa/icon_delivery_network.png',
						'title': 'Infrastructure as a Service',
					}
				]
			}
		]
	}

	checkData = () => {
		let data = [] 
		console.log('this.props.sub_title', this.props.sub_title)
		switch (this.props.title){
			case 'Corporate':
				data = this.dataCorporate();
			break;
			case 'Education':
				data = this.dataEducation();
			break;
			case 'Goverment':
				data = this.dataGoverment()
			break;
			case 'Hospitally':
				data = this.dataHospitally()
			break;
			case 'Manufacture':
				data = this.dataManufacture()
			break;
			default:
			console.log('No case: L30 func checkData MainSolutions')
			break;
		}
		return data;
	}
    render(){
        return (
        <section>
        <style>
        {`
        	.solutioneducation-image {
			    width: auto;
			    object-fit: cover;
			    height: 80px;
			}
        	// .card.support:hover {
        	// 	transition-timing-function: ease-out;
        	// 	transition: 0.2s;
        	// 	transform: translateY(-20px);
        	// }
        	.box-shadow {
        		box-shadow: 5px 5px 10px 0px #d4d4d4;
        	}
        `}
        </style>
	    <section className="solutioneducation-container03">
          <div className="solutioneducation-container04">
            <span className="solutioneducation-text17">{sessionStorage.getItem('lang') === "1" ? "Solution" : "Solusi"}</span>
            <h2 className="solutioneducation-text18 fs-36 fw-bold mb-0">{sessionStorage.getItem('lang') === "1" ? "Our Product" : "Produk Kami"}</h2>
            <span className="solutioneducation-text19 text-center">
              <span>{(typeof this.props.sub_title !== 'undefined') ?  formatTitle( this.props.sub_title !== false ? this.props.sub_title : '' ) : `Other Solutions for ${this.props.title}`}</span>
            </span>
          </div>
          <div className="solutioneducation-container11 pt-5 mx-auto" style={{"backgroundColor": "#f5f5f5", "maxWidth":"1100px"}}>
	          <div className="row p-4" style={{"height":"auto"}}>
	          {
	          	this.checkData().map((row, index) => {
	          		return(
	          		<React.Fragment key={index}>
	          			{
	          				row.arr_data.map((item, idx) => {
	          					return(
	          						<Col xs={6} md={3} lg={3} key={idx} className="mb-3">
			          					<NavLink to={row.url} className="card support box-shadow border-0" style={{"minHeight": "180px", "borderRadius":"10%"}}>
			          						<img loading='lazy' alt={`Nexa ${item.title}`} src={item.url_image} className="solutioneducation-image align-self-center card-img-top mt-3"/>
			          						<span className="solutioneducation-mobile-text22 card-body">
			          						<div className="card-text" style={{fontSize:"0.8rem"}}>{item.title}</div>
			          						</span>
			          					</NavLink>
	          						</Col>
	          					)
	          				})
	          			}
	          		</React.Fragment>
	          		)

	          	})
	          }
	          </div>
          </div>
        </section>
        </section>
        )
    }
}